import DesktopConsoleAndChannelStrips from "./DesktopConsoleAndChannelStrips";
import PatchedInTextBarMobileOnly from "../molecules/MobilePatchedInTextBar";
import MixConsole from "../molecules/MixConsole/MixConsole";
import DesktopPatchedInControlBar from "../molecules/DesktopPatchedInControlBar";
import MobileActionControlBar from "../molecules/MobileActionControlBar";
import { State } from "../state/reducer";
import { Dispatch } from "react";
import Action from "../state/actions";
import { getActiveInstrument, isReportCardMode } from "../state/selectors";
import MixConsoleReportCard from "../molecules/MixConsole/MixConsoleReportCard";
import PatchedInFixedStatusBar from "../molecules/PatchedInFixedStatusBar";
import ReportCarFixedStatusBar from "../molecules/ReportCardFixedStatusBar";
import MobileFailControlBar from "../molecules/MobileFailControlBar";

interface Props {
  state: State;
  dispatch: Dispatch<Action>;
}

export default function SingleTrackMixModeScreen({ state, dispatch }: Props) {
  const instrument = getActiveInstrument(state);
  const reportCardMode = isReportCardMode(state);

  return (
    <div>
      {reportCardMode ? (
        <>
          <ReportCarFixedStatusBar state={state} instrument={instrument} />
          <MobileFailControlBar />
        </>
      ) : (
        <>
          <PatchedInFixedStatusBar instrument={instrument} />

          <div className="hidden md:block">
            <DesktopPatchedInControlBar
              instrument={instrument}
              dispatch={dispatch}
            />
          </div>

          <div className="mb-1 block md:hidden">
            <PatchedInTextBarMobileOnly instrument={instrument} />
          </div>

          <div className="block md:hidden">
            <MobileActionControlBar
              state={state}
              dispatch={dispatch}
              instrument={instrument}
            />
          </div>
        </>
      )}

      <div className="hidden md:block">
        <DesktopConsoleAndChannelStrips
          state={state}
          dispatch={dispatch}
          reportCardMode={reportCardMode}
        />
      </div>

      <div className="mb-2 md:hidden">
        {reportCardMode ? (
          <MixConsoleReportCard
            state={state}
            instrument={instrument}
            dispatch={dispatch}
          />
        ) : (
          <MixConsole
            state={state}
            instrument={instrument}
            onRequestPlaybackChange={(instrument, params) => {
              dispatch({
                type: "requestPlaybackChange",
                payload: { instrument, params },
              });
            }}
          />
        )}
      </div>
    </div>
  );
}
